import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v11h18V3zm-2 6h-4c0 1.62-1.38 3-3 3s-3-1.38-3-3H5V5h14v4zm-4 7h6v5H3v-5h6c0 1.66 1.34 3 3 3s3-1.34 3-3z"
}), 'AllInboxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AllInboxSharp.js
// module id = 2020
// module chunks = 2